import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=0ef0f15b&scoped=true&"
import script from "./set-password.vue?vue&type=script&lang=js&"
export * from "./set-password.vue?vue&type=script&lang=js&"
import style0 from "./set-password.vue?vue&type=style&index=0&id=0ef0f15b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef0f15b",
  null
  
)

export default component.exports